/**
 * Modal Store for Alpine.js
 */
export default function registerModalStore(Alpine) {
  Alpine.store('modal', {
    current: null,
    data: null,

    open(id, data = null) {
      this.current = id
      this.data = data
    },

    close() {
      this.current = null
      this.data = null
    },

    isOpen(id) {
      return this.current === id
    }
  })
}
